import { Button, FeaturedIcon } from "@myhealth-raccoon/components";
import React from "react";
import { useClinicSelector } from "src/hooks/useAsyncSelector";

export function Cancelled() {
    const { data: clinic } = useClinicSelector();

    return <div className="text-center m-auto">
        <FeaturedIcon className="mx-auto mb-5" />
        <h1 className="text-gray-900 font-semibold text-lg mb-2">Your booking was cancelled</h1>
        <p>Don’t forget to remove the appointment from your calendar!</p>
        <div className="mt-8 flex flex-row gap-3 justify-center">
            <Button href={`${import.meta.env.VITE_MYHEALTH_WEBSITE}${clinic?.url}`}>
                Book again
            </Button>
            <Button variant="link" color="gray" href={`${import.meta.env.VITE_MYHEALTH_WEBSITE}`}>
                Go to home
            </Button>
        </div>
    </div>
}